import React, {Component} from 'react';

class About extends Component{
    render(){
        return(
        <div>
            <h1 style={{fontFamily:"Lobster"}}> About Me</h1>
            <p style={{fontSize:"30px" , fontFamily:"Dancing Script"}}> Having no limit is my goal. Connecting with everyone to know every detail and use most advanced mechinery. </p>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/about.js